// extracted by mini-css-extract-plugin
export default {"totalContainer":"Total_totalContainer__-x9Na","btnsContainer":"Total_btnsContainer__3ItFc","attention":"Total_attention__7IfJg","totalSkelleton":"Total_totalSkelleton__TyIuo"};